export enum NewsCardMode {
  HEADLINES = 0,
  NEWS = 1,
}
